import React, { useState } from "react";
import DetailsTable from "./DetailsTable";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Table from "../../Table";
import {
  deleteProductItem,
  sendProductDelivery,
} from "../../../../redux/reducer/productReducer";
import { submitItemsToDelivery } from "../../../../redux/reducer/cartReducer";
import LoadingSpinner from "../../../animation/LoadingSpinner";

const DeliveredProduct = ({
  data,
  cartID,
  setEditingProducts,
  refreshData,
  loading,
}) => {
  const [editingOrder, setEditingOrder] = useState(null);
  const [pricingOrder, setPricingOrder] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const headers = [
    "ID",
    "Prod. No",
    "Image",
    "Name",
    "Info",
    "Size",
    "Status",
    "Price Pro",
    "Fees",
    "Link",
    "Count",
    "isPacking",
    "Area",
    "created At",
    "Actions",
  ];

  const handleDelete = (orderId) => {
    if (window.confirm("Are you sure you want to delete this Product?")) {
      dispatch(deleteProductItem(orderId))
        .unwrap()
        .then(() => {
          alert(t("ProductDeleted"));
          if (refreshData) refreshData();
        })
        .catch((error) => alert(error || "Failed to delete order."));
    }
  };

  const handleSubmitDelivery = async () => {
    try {
      // Step 1: Extract IDs from products
      const productIds = data
        .filter((product) => product.status === "shipped")
        .map((product) => product._id);

      // console.log(productIds)
      // Step 2: Send them to sendProductShipping

      await Promise.all(
        productIds.map((id) => dispatch(sendProductDelivery(id)).unwrap())
      );
      // console.log(cartID)

      // Step 3: After all requests succeed, execute the basic dispatch
      await dispatch(submitItemsToDelivery({ cartId: cartID })).unwrap();

      setShowModal(false);
      if (refreshData) refreshData();
    } catch (error) {
      alert(error || "Failed to submit request.");
    }
  };

  const handleUpdate = () => {};

  if (loading) {
    return <LoadingSpinner />;
  }
  // console.log(data[0].status)
  return (
    <>
      <Table
        title={t("Delivered Products")}
        headers={headers}
        data={data}
        EditingProducts={setEditingProducts}
        renderRow={(product, index) => (
          <DetailsTable
            key={product._id || index}
            index={index + 1}
            details={{
              id: product._id,
              number: index + 1,
              Box: product.ReferenceCode,
              link: product.link,
              info: product.additionalInfo,
              Count: product.count,
              history: product.createdAt,
              weight: product.weight,
              price: product.price || "00.0",
              status: product.status,
              DShippingFees: product.DShippingFees || "00.0",
              category: product.category,
              brand: product.brand,
              area: product.area,
              currency: product.currency,
              name: product.name,
              image:
                product.img || "https://api.markaship.com/uploads/waiting.png",
              isPacking: product.isPacking,
              PackingFees: product.PackingFees,
              size: product.size,
            }}
            isEditing={editingOrder === product._id}
            isPricing={pricingOrder === product._id}
            setEditingOrder={setEditingOrder}
            setPricingOrder={setPricingOrder}
            onDelete={() => handleDelete(product._id)}
            onUpdate={handleUpdate}
            refreshData={refreshData}
          />
        )}
      />
    </>
  );
};

export default DeliveredProduct;
